module.exports = __webpack_public_path__ + "img/Butterfly_00184.88315bd0.png";